import * as React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Grid, GridColumn, GridToolbar, } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { MultiSelect, AutoComplete } from "@progress/kendo-react-dropdowns";
import { Checkbox, Input, Switch } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Error, FloatingLabel } from "@progress/kendo-react-labels";
import { process } from '@progress/kendo-data-query';
import { getter } from "@progress/kendo-react-common";
import { passwordValidation } from "../utils/passwordValidation";
import { deleteField, searchUsers } from "../actions";

const FormInput = (fieldRenderProps) => {
  const { validationMessage, visited, ...others } = fieldRenderProps;
  return (
    <div>
      <Input {...others} />
      {
        visited && validationMessage && <Error direction={"end"} style={{ flexDirection: 'column' }}>{validationMessage}</Error>
      }
    </div>
  );
};

const initialDataState = {
  skip: 0,
  take: 10,
  // sort: [
  //   { field: 'lastName', dir: 'asc' }
  // ],
}

const SSOForm = (props) => {
  const [displayAdditional, setDisplayAdditional] = React.useState(false);
  const [additionalFields, setAdditionalFields] = React.useState(props.item && props.item.AdditionalDetails ? props.item.AdditionalDetails : []);
  const [agency, setAgency] = React.useState(props?.item?.agency ?? '');
  const [dataState, setDataState] = React.useState(initialDataState);
  const [searchAzure, setSearchAzure] = React.useState('');
  const [searchInput, setSearchInput] = React.useState('');
  const [isAdmin, setIsAdmin] = React.useState(false);
  const { token } = useSelector(state => state.authReducer);
  const { azure } = useSelector(state => state.azureReducer);

  const dispatch = useDispatch();

  const submit = (event, props) => {
    let outputFields = additionalFields.filter((field) => field.propertyName.trim().length != 0 && field.description.trim().length != 0);
    props.onSubmit({ ...event, additionalDetails: outputFields, agency: agency }, event.Groups);
  }

  React.useEffect(() => {
    console.log(azure);
  }, [azure])

  const FormMultiSelect = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;

    return (
      <div>
        <MultiSelect
          data={props.groups}
          textField="name"
          dataItemKey="id"
          {...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    )
  }

  const floSwitch = (fieldRenderProps) => {
    return FormSwitch(fieldRenderProps, "FLO", props.item.flo);
  }

  const cfrSwitch = (fieldRenderProps) => {
    return FormSwitch(fieldRenderProps, "28 CFR Completed", props.item.cfrComplete)
  }

  const floInfoSwitch = (fieldRenderProps) => {
    return FormSwitch(fieldRenderProps, "FLO Information Sent", props.item.floInfo)
  }
  
  const floDate = (fieldRenderProps) => {
    return FormDate(fieldRenderProps)
  }
  
  const FormDate = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    return (
      <div>
        <DatePicker popupSettings={{ popupClass: 'date-override' }}{...others} />
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    ); 
  }

  const FormSwitch = (fieldRenderProps, label, defaultCheck) => {
    const { validationMessage, visited, disabled, ...others } = fieldRenderProps;

    return (
      <div>
        <Switch disabled={disabled} defaultChecked={defaultCheck} {...others} />
        <label
          style={{ paddingLeft: '10px' }}
          className="k-checkbox-label">
          {label}
        </label>
        {visited && validationMessage && <Error>{validationMessage}</Error>}
      </div>
    );
  }

  const select = (p) => {
    function generateRandomStringCustom(length, characters) {
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    }
    const alphanumericChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$?';
    const specialChars = '!@#$?'
    let firstName = "", lastName = "";
    if (p.displayName) {
      if (p.displayName.includes(' ')) {
        lastName = p.displayName.split(' ')[0].replaceAll(",", "");
        firstName = p.displayName.split(' ')[1]
      }
    }
    props.onSubmit({
      azure: true,
      email: p.mail,
      firstName,
      lastName,
      enabled: true,
      password: generateRandomStringCustom(14, alphanumericChars) + generateRandomStringCustom(1, specialChars)
    });
  }

  return <Dialog
    title={props.item.id ? 'Edit User' : 'Create SSO User'}
    style={{ zIndex: 2 }}
    onClose={props.cancelEdit}
  >
    <FloatingLabel
      label='Search'
      editorId='search-input'
      style={{ marginBottom: '20px' }}
      editorValue={searchAzure}
    >
    <Input
      id='search-input'
      value={searchAzure}
      onChange={e => {
        setSearchAzure(e.value)
      }}
    />
    </FloatingLabel>
    <Button 
      style={{
        minHeight: 25,
        padding: '10px 20px',
        marginRight: 15,
        marginLeft: 15
      }}
      onClick={() => {
          dispatch(searchUsers(token, searchAzure));
      }}
    >
      Search
    </Button>
    <Grid
      data={process(azure, dataState)}
      onDataStateChange={e => setDataState(e.dataState)}
      pageable={true}
      sortable={true}
      scrollable='scrollable'
      className='flo-user-grid'
    >
          <GridToolbar>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <div 
                  style={{
                    paddingLeft: 30,
                  }}
                >
                  <FloatingLabel
                    label='User Filter'
                    editorId='search-input'
                    editorValue={searchInput}
                  >
                    <Input
                      id='search-input'
                      value={searchInput}
                      onChange={e => {
                        setSearchInput(e.value)
                        setDataState({
                          ...dataState,
                          filter: {
                            logic: 'or',
                            filters: [
                              'mail',
                              'displayName',
                            ].map(field => {
                              return {
                                field,
                                operator: 'contains',
                                value: e.value
                              }
                            })
                          }
                        });

                      }}
                    />
                  </FloatingLabel>
                </div>
              </div>
            <div>
          </div>
        </div>
      </GridToolbar>
      <GridColumn field="mail" title="Email" />
      <GridColumn field="displayName" title="Display Name" />
      <GridColumn width={370} cell={props => 
        <td {...props} style={{ textAlign: 'center' }}>
          <Button
                  className="k-button"
                  style={{
                    minHeight: 25,
                    padding: '10px 20px',
                    marginRight: 15,
                    color: 'blue',
                    width: '100%'
                  }}
                  onClick={() => select(props.dataItem)}
          >
            Select
          </Button>
        </td>
      } />
    </Grid>
  </Dialog>
}

const styles = {
  formElement: {
    width: 465,
    maxHeight: 525,
    minHeight: 525
  },
  formField: {
    marginTop: 10,
    marginBottom: 25,
  },
  formLabel: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  adminSection: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row'
  },
  modalBtn: {
    padding: '10px 15px'
  },
  accountDiv: {
    backgroundColor: '#F5F5F5',
    padding: '8px',
    border: '2px solid #DCDCDC',
    borderRadius: '6px'
  }
  //    padding: 8px 24px;
}

export default SSOForm;